module.exports = __webpack_public_path__ + "static/media/Popup-ilmoitus-thumbnail.8753e9e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/screenCaptures/Popup-ilmoitus-thumbnail.png
// module id = 1430
// module chunks = 0